/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2019-2020金华企客观网络科技有限公司All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : </li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2020年08月08日</li>
 * <li>@author     : ____′↘企万慧</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
import Ajax from '../js/common/ajax';

export default {
	voucherCount() {
		return Ajax.get("/home/voucher/count")
	},
	invoiceCount() {
		return Ajax.get("/home/invoice/count")
	},
	unVoucherCount() {//未审核数量
		return Ajax.get("/home/unVoucher/count")
	},
	chart: {
		revenueProfit() {
			return Ajax.get("/home/chart/revenueProfit")
		},
		cost(params = {}) {
			return Ajax.get("/home/chart/cost" , params)//传递账套准则给后端，按准则设置不同的科目代码
		},
		cash() {
			return Ajax.get("/home/chart/cash")
		}
	}
}
